/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_ConfirmInputs */

const en_plan_change_confirm = /** @type {(inputs: Plan_Change_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm change`)
};

const es_plan_change_confirm = /** @type {(inputs: Plan_Change_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar cambio`)
};

/**
* | output |
* | --- |
* | "Confirm change" |
*
* @param {Plan_Change_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_confirm = /** @type {((inputs?: Plan_Change_ConfirmInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_ConfirmInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_confirm(inputs)
	return en_plan_change_confirm(inputs)
});